import { Controller } from "@hotwired/stimulus"

// Les deux branches de `/learn/inscription` — carte #1592, `RF-13`.
//
// 🔴 **Le piège que ce contrôleur existe pour éviter, et qui a déjà coûté une
// fois** (formulaire de moratoire) : une section masquée dont les champs portent
// `required` **bloque tout le formulaire en silence**. Le navigateur refuse de
// soumettre, tente de focaliser un champ invisible, et n'affiche aucun message.
// L'utilisateur clique, rien ne se passe, et rien ne dit pourquoi.
//
// Un champ `disabled` est exclu **de la validation HTML5 ET de l'envoi**. C'est
// donc le seul geste correct : masquer ne suffit pas, il faut désactiver.
// Précédent : `moratorium_form_controller.js#setSectionFieldsDisabled`.
//
// ⚠️ **Ce contrôleur n'est pas une garde.** L'exclusivité `RF-13` est tenue par
// la contrainte `CHECK` de la base et par la validation du modèle ; le serveur
// ne lit que les champs de la branche déclarée. Ici, on ne fait que l'interface.
export default class extends Controller {
  static targets = ["schoolSection", "postBacSection", "orderKind"]

  connect() {
    this.apply()
  }

  apply() {
    const postBac = this.selectedOrderKind() === "post_bac"
    this.toggle(this.postBacSectionTarget, postBac)
    this.toggle(this.schoolSectionTarget, !postBac)
  }

  toggle(section, visible) {
    // The `hidden` ATTRIBUTE and `style.display`, not a class: the sections carry an inline
    // `display: flex`, which beats both the `.hidden` class and the bare attribute — the
    // toggle never hid anything.
    section.hidden = !visible
    section.style.display = visible ? "flex" : "none"
    // Voir l'en-tête : masquer sans désactiver laisse un `required` invisible
    // bloquer la soumission.
    section.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !visible
    })
  }

  selectedOrderKind() {
    const checked = this.orderKindTargets.find((input) => input.checked)
    return checked ? checked.value : "school"
  }
}
